/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

/** Import exported objects from lower level directories */



/** Import exported objects from current directory files */

import { AppdiscoveryTypes } from './appDiscovery.types';
import { DriverinstallTypes } from './driverInstall.types';
import { DriverupdaterecommendationTypes } from './driverupdaterecommendation.types';
import { KiteTypes } from './Kite.types';
import { LocalgamesTypes } from './localgames.types';
import { NvappinstallTypes } from './nvappinstall.types';
import { NvcpldisplaypluginTypes } from './NvCplDisplayplugin.types';
import { NvcplpluginTypes } from './NvCplplugin.types';
import { NvigoutilTypes } from './nvigoutil.types';
import { NvocTypes } from './NvOc.types';
import { NvworkstationTypes } from './NvWorkstation.types';
import { OverclockingnvcTypes } from './OverClockingNvc.types';
import { RiseTypes } from './Rise.types';

/** Export current level object and nested objects */

export module NvappTypes {
export import Appdiscovery = AppdiscoveryTypes;
export import Driverinstall = DriverinstallTypes;
export import Driverupdaterecommendation = DriverupdaterecommendationTypes;
export import Kite = KiteTypes;
export import Localgames = LocalgamesTypes;
export import Nvappinstall = NvappinstallTypes;
export import Nvcpldisplayplugin = NvcpldisplaypluginTypes;
export import Nvcplplugin = NvcplpluginTypes;
export import Nvigoutil = NvigoutilTypes;
export import Nvoc = NvocTypes;
export import Nvworkstation = NvworkstationTypes;
export import Overclockingnvc = OverclockingnvcTypes;
export import Rise = RiseTypes;
}


